module.exports = __webpack_public_path__ + "img/walkgray.209cf4ce.svg";